"use strict";function startMatchRuleFromPartner$(r){return ddSdk_1.ddSdk.invokeAPI(apiName,r)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startMatchRuleFromPartner$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.pbp.startMatchRuleFromPartner";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.10"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.10"},_a)),exports.startMatchRuleFromPartner$=startMatchRuleFromPartner$,exports.default=startMatchRuleFromPartner$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/pbp/startMatchRuleFromPartner.js
// module id = 981
// module chunks = 106